var module = angular.module('octopusApp.projects');

module.directive('azureWebSiteSelector', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            model: '=',
            projectId: '=',
            getAccountId: '=',
            isAccountBound: '='
        },
        templateUrl: 'areas/projects/actions/azure_web_app/azure_web_site_selector.html',
        controllerAs: 'vm',
        controller: function ($scope, octopusRepository, busy, $timeout) {
            var vm = this;
            vm.model = $scope.model;
            vm.projectId = $scope.projectId;
            var getAccountId = $scope.getAccountId;
            vm.isLoading = busy.create();
            vm.changed = changed;

            vm.reset = {
                name: undefined,
                resourceGroupName: undefined
            };

            function changed() {
                if (vm.selectedSite) {
                    vm.model.name = vm.selectedSite.Name;
                    vm.model.resourceGroupName = vm.selectedSite.ResourceGroup;
                } else {
                    vm.model.name = null;
                    vm.model.resourceGroupName = null;
                }
            }

            function getWebSites() {
                vm.isLoading.promise(octopusRepository.Accounts.get(getAccountId())
                    .then(function (account) {
                        return octopusRepository.Accounts.getWebSites(account)
                            .then(function (sites) {
                                vm.sites = sites;

                                if (vm.model.name) {
                                    vm.selectedSite = sites.filter(function (site) {
                                        return site.Name === vm.model.name && site.ResourceGroup === vm.model.resourceGroupName;
                                    })[0];
                                }
                            });
                    })
                );
            }

            function resetWebSites() {
                vm.isLoading.promise($timeout(function () {
                    vm.sites = [];
                }, 100));
            }

            $scope.$watch(function () { return vm.isBound; }, function () {
                if (!vm.isBound && (!vm.sites || vm.sites.length === 0)) {
                    getWebSites();
                }
            });

            $scope.$watch(getAccountId, function () {
                    if (!getAccountId()) {
                        resetWebSites();
                        return;
                    }

                    if (vm.isBound) {
                        resetWebSites();
                    }
                    else {
                        getWebSites();
                    }
                }
            );
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_web_app/azure_web_site_selector.js
// module id = 493
// module chunks = 1